import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter, DocumentListCountFilter } from "./Filter";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { DocumentList } from "./DocumentList";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { IPermissionProps, ILogin } from "../../models/Login";


interface IProps {
    toast: any
}

export interface IDocumentCounList {
    pO_Id?: number,
    req_Id?: number,
    login_ID?: number,
    user_Name?: string,
    branch_ID?: number,
    branchName?: string,
    company_ID?: number,
    company_Name?: string,
    recruiter_Login_ID?: number,
    recruiter_User_Name?: string,
    recruiter_Branch_ID?: number,
    recruiter_BranchName?: string,
    recruiter_Company_ID?: number,
    recruiter_Company_Name?: string,
    consultant_ID?: number,
    consultant_Name?: string,
    prime_Vendor_Company_ID?: number,
    prime_Vendor_Company?: string,
    sub_Vendor_Company_ID?: number,
    sub_Vendor_Company?: string,
    pO_Date?: Date,
    project_Start_Date?: Date,
    project_End_Date?: Date,
    project_Client_Name?: string,
    prime_Vendor_Docs_Count?: number,
    prime_Vendor_Docs_Exp_Count?: number,
    sub_Vendor_Docs_Count?: number,
    sub_Vendor_Docs_Exp_Count?: number,
    consultant_Docs_Count?: number,
    consultant_Docs_Exp_Count?: number,
}

export const EmptyFilter: DocumentListCountFilter = {
    fromDate: null,
    toDate: null,
    date_Filter_Type: "PO Date",
    po_Status: null,
    consultant: null,
    subVendor_Company: null,
    primeVendor_Company: null,
    company: null,
    branch: null,
    sales: null,
    recruiter: null,
};

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IDocumentCounList>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState<DocumentListCountFilter>(EmptyFilter);
    const [openSubtable, setOpenSubtable] = useState({ open: false, singleData: {}, type: 0 } as { open: boolean, singleData: IDocumentCounList, type: number });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData()} />
            </React.Fragment>
        );
    };

    const poDate = (rowData: IDocumentCounList) => {
        let date;
        if (rowData.pO_Date) date = format(new Date(rowData.pO_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const startDate = (rowData: IDocumentCounList) => {
        let date;
        if (rowData.project_Start_Date) date = format(new Date(rowData.project_Start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const endDate = (rowData: IDocumentCounList) => {
        let date;
        if (rowData.project_End_Date) date = format(new Date(rowData.project_End_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const header = () => <p>Document List Count</p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const newFilter: any = {
            date_Filter_Type: filters.date_Filter_Type,
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            consultant: filters.consultant?.consultant_Name,
            subVendor_Company: filters.subVendor_Company?.vendor_Company_Name,
            primeVendor_Company: filters.primeVendor_Company?.vendor_Company_Name,
            company: filters.company,
            branch: filters.branch,
            sales: filters.sales,
            recruiter: filters.recruiter,
        };

        const respone = await Fetch("vwPODetails/getDocumentsCountListAPW", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(newFilter)}`, props.toast);

        if (respone) {
            const data: { data: IDocumentCounList[], totalRecords: number } = await respone.json();
            setTotalRecords(prev => prev = data.totalRecords);
            setTableData({ tableData: data.data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    useEffect(() => {
        loadTableData();
    }, [lazyParams, filters]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filter={filters} setFilter={(filters: DocumentListCountFilter) => setFilters(filters)} toast={props.toast} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small"
                lazy
                exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                dataKey="pO_Id" showGridlines stripedRows responsiveLayout="scroll"
                value={tableData.tableData}
                emptyMessage="No Data found."
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: "4rem" }} />
                <Column field="user_Name" header="Sales Manager" />
                <Column field="branchName" header="Sales Branch" />
                <Column field="company_Name" header="Sales Comp" />
                <Column field="recruiter_User_Name" header="Recruiter" />
                <Column field="recruiter_BranchName" header="Rec Branch" />
                <Column field="recruiter_Company_Name" header="Rec Comp" />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="prime_Vendor_Company" header="PV Company" />
                <Column field="sub_Vendor_Company" header="SV Company" />
                {/* <Column field="pO_Date" header="PO Date" body={(rowData: IDocumentCounList) => poDate(rowData)} /> */}
                <Column field="pO_Date" header="PO Date" style={{minWidth:'100px'}} sortable body={(rowData: any) => safeFormatDate( rowData.pO_Date, "dd/MM/yyyy", DateFormat )}/>
                {/* <Column field="project_Start_Date" header="Start Date" body={(rowData: IDocumentCounList) => startDate(rowData)} /> */}
                <Column field="project_Start_Date" header="Start Date" style={{minWidth:'100px'}} body={(rowData: any ) => safeFormatDate(rowData.project_Start_Date, 'dd/MM/yyyy', DateFormat)} />
                {/* <Column field="project_End_Date" header="End Date" body={(rowData: IDocumentCounList) => endDate(rowData)} /> */}
                <Column field="project_End_Date" header="End Date" style={{minWidth:'100px'}} body={(rowData: any) => safeFormatDate(rowData.project_End_Date, 'dd/MM/yyyy', DateFormat)} />
                
                <Column field="project_Client_Name" header="Client Name" />
                <Column field="prime_Vendor_Docs_Count" header="PV Docs Count" body={(rowData: IDocumentCounList) => {
                    return <p className="cursor-pointer underline" onClick={() => setOpenSubtable({ open: true, singleData: rowData, type: 3 })}><span className="text-cyan-700">{rowData.prime_Vendor_Docs_Count}</span>/<span style={{ color: "red" }}>{rowData.prime_Vendor_Docs_Exp_Count}</span></p>
                }} />
                <Column field="sub_Vendor_Docs_Count" header="SV Docs Count" body={(rowData: IDocumentCounList) => {
                    return <p className="cursor-pointer underline" onClick={() => setOpenSubtable({ open: true, singleData: rowData, type: 2 })}><span className="text-cyan-700">{rowData.sub_Vendor_Docs_Count}</span>/<span style={{ color: "red" }}>{rowData.sub_Vendor_Docs_Exp_Count}</span></p>
                }} />
                <Column field="consultant_Docs_Count" header="Consultant Docs Count" body={(rowData: IDocumentCounList) => {
                    return <p className="cursor-pointer underline" onClick={() => setOpenSubtable({ open: true, singleData: rowData, type: 1 })}><span className="text-cyan-700">{rowData.consultant_Docs_Count}</span>/<span style={{ color: "red" }}>{rowData.consultant_Docs_Exp_Count}</span></p>
                }} />
            </DataTable>
            <DocumentList open={openSubtable.open} singleData={openSubtable.singleData} type={openSubtable.type} hideDialogue={() => setOpenSubtable({ open: false, singleData: {}, type: 0 })} toast={props.toast} />
        </>
    );
}